














import {Component, Vue, Prop} from 'vue-property-decorator';
import {EventBus} from "@/helpers/EventBus";
import {AlertChannel, AlertService, AlertSettingsRequest} from "@/services/AlertService";
import {Inject} from "vue-typedi";
import { Zone } from '@/model/Zone';

@Component
export default class AlertForm extends Vue {

    @Prop({default: {}}) zone: Zone;

    @Inject()
    alertService!: AlertService;

    email: string = "";
    private isEmailValidationEnabled: boolean = false;

    get storeId(): string {
        return sessionStorage.getItem("storeId");
    }

    public addAlertEmail() {
        if (this.email == "") {
            return;
        }

        this.isEmailValidationEnabled = true;
        if (!this.isEmailValid()) {
            return;
        }

        const request = {
            identifier: this.email,
            channel: AlertChannel.EMAIL,
            storeId: this.storeId,
            zoneCode: this.zone.zoneCode
        } as AlertSettingsRequest;
        
        this.alertService.insertAlert(request).then(alertSettings => {
            EventBus.$emit(EventBus.REFRESH_ALERT_SETTINGS, alertSettings);
        }).catch(error => console.error(error));

        this.email = "";
        this.isEmailValidationEnabled = false;
    }

    isEmailValid(): boolean {
        if (!this.isEmailValidationEnabled) {
            return true;
        }

        return this.email === '' || this.email.endsWith('@auchan.fr') || this.email.endsWith('@partner.auchan.fr');
    }
}
